/**
 * Get Current User with Clinic Information
 *
 * Fetches the current authenticated user and their associated clinic context.
 * Uses AWS Cognito for authentication and our API for profile data.
 */

import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { api } from './api';

/**
 * Gets the current authenticated user along with their clinic context
 * @returns {Promise<{user: object, clinicId: string, role: string}>}
 */
export async function getCurrentUserWithClinic() {
  // Get the authenticated user from Cognito
  const cognitoUser = await getCurrentUser();
  const attributes = await fetchUserAttributes();

  if (!cognitoUser) {
    throw new Error('User not authenticated');
  }

  const user = {
    id: cognitoUser.userId,
    username: cognitoUser.username,
    email: attributes.email,
    ...attributes,
  };

  // Fetch profile with clinic info from our API
  const profile = await api.getCurrentProfile();

  if (!profile) {
    throw new Error('Profile not found');
  }

  return {
    user,
    clinicId: profile.clinic_id,
    role: profile.role,
  };
}
